import React, { useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import {
  TextInput,
  SelectBox,
  Check,
  DatePickerBox,
  DateTimePickerBox,
  RadioGroupBox,
  FileUploader,
  ToastEditor,
  FileMultipleUploader,
} from "../../components";
import { useForm } from "../../hooks";
import Handler from "../../Handler";
import API from "../../api";
import { SnackbarContext, DialogContext } from "../../contexts";
import { useHistory } from "react-router-dom";
import Util from "../../util";

export const MembershipAddPage = (props) => {
  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [
    formData,
    formMeta,
    formChange,
    setFormData,
    setFormMeta,
    formReset,
  ] = useForm(
    {
      title: "",
      content: null,
      fileList: [],
    },
    {
      title: {
        key: "title",
        label: "제목",
        fullWidth: true,
      },
      content: {
        key: "content",
        label: "내용",
      },
      fileList: {
        type: "file",
        key: "fileList",
        label: "파일 첨부",
        path: "/notcie/file",
        max: 10,
      },
    }
  );

  const requsetAdd = () => {
    let body = Util.Form.formToBody(formData, formMeta);
    console.log("requsetAdd body", body);

    API.Membership.Post(body).then(
      (res) => {
        let result = res.data;
        console.log("result", result);
        history.push("/membership/detail/" + result.no);
      },
      (err) => {
        updateSnackbar({
          type: "error",
          open: true,
          message: err.data.message,
        });
      }
    );
  };

  return (
    <article className="basic-page">
      <section className="content-header__container">
        <header>
          <h1>유료게시판 등록</h1>
        </header>
        <div className="button__box">
          <Button variant="contained" onClick={requsetAdd}>
            등록
          </Button>
        </div>
      </section>
      <section className="form__container">
        <header>
          <h3>기본 정보</h3>
        </header>
        <div className="flex">
          <TextInput
            value={formData.title}
            onChange={formChange}
            meta={formMeta.title}
          ></TextInput>
          <ToastEditor
            value={formData.content}
            onChange={formChange}
            meta={formMeta.content}
          ></ToastEditor>
          <FileMultipleUploader
            value={formData.fileList}
            onChange={formChange}
            meta={formMeta.fileList}
          ></FileMultipleUploader>
        </div>
      </section>
    </article>
  );
};
